module.exports = __webpack_public_path__ + "img/item5-4.1f39ebe5.jpg";